

export default class NetMsgDataToBuffer {

    private static bufferType1(msgDataMap, dataBuffer) {
        var requestBuffer = new ArrayBuffer(8 + dataBuffer.length);
        let int32Array = new Int32Array(requestBuffer, 0, 2);
        int32Array[0] = msgDataMap[0];
        int32Array[1] = dataBuffer.length

        let uint8Array = new Uint8Array(requestBuffer, 8, dataBuffer.length)
        uint8Array.set(dataBuffer);

        return requestBuffer
    }

    private static getRealBufferType1(msgDataMap, data : ArrayBuffer) : Uint8Array {
        let dataBuffer  = new Uint8Array(data, 8, data.byteLength - 8);
        return dataBuffer;
    }

    static createRequestBuffer(msgDataMap, data) : ArrayBuffer {
        //更加MsgName
        let dataBuffer : Uint8Array  = msgDataMap[1].encode(data).finish();
        let requestBuffer : ArrayBuffer
        if (msgDataMap[4] == 1) {   //协议1
            requestBuffer =  this.bufferType1(msgDataMap, dataBuffer)
        }

        return requestBuffer
    }

    static getResponeData(msgDataMap, protoData) {

        // let dataRealBuffer;
        // if (msgDataMap[4] == 1) {   //协议1
        //     dataRealBuffer = this.getRealBufferType1(msgDataMap, data);
        // }
        //更加MsgName
        let responeData = msgDataMap[3].decode(protoData);
        return responeData;
    }
}
